import React from "react";
import PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import { Grid, Typography } from "@material-ui/core";

import { CustomSlider } from "./styles.theme";
import { useStyles } from "./styles";
import ValueLabelComponent from "../valueLabel";

const ThumbComponent = React.forwardRef(function CustomThumb(props, ref) {
  return (
    <span ref={ref} {...props}>
      <span className="bar" />
      <span className="bar" />
    </span>
  );
});

export default function RatingSlider(props) {
  const classes = useStyles();

  const sliderOnChange = (e, value) => {
    e.preventDefault();
    props.sliderOnChange(value);
  };

  const lineArray = props.labelEnd.split("\n");
  const line1 = lineArray[0];
  const line2 = lineArray[1];

  return (
    <Paper className={classes.root}>
      <CustomSlider
        marks={props.marks}
        step={props.step}
        min={props.min}
        max={props.max}
        ThumbComponent={ThumbComponent}
        onChange={(e, value) => sliderOnChange(e, value)}
        defaultValue={props.default}
        value={props.value}
        open={true}
        valueLabelDisplay={props.valueLabel} //should be "on", "off" or "auto"
        ValueLabelComponent={ValueLabelComponent}
      />
      <Grid item xs={12}>
        <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
          <Grid className={classes.good} item xs={4}>
            <Typography variant="subtitle2" gutterBottom>
              {props.labelStart}
            </Typography>
          </Grid>
          <Grid className={classes.average} item xs={4}>
            <Typography variant="subtitle2" gutterBottom>
              {props.labelMid}
            </Typography>
          </Grid>
          <Grid className={classes.poor} item xs={4}>
            <Typography variant="subtitle2" gutterBottom>
              {line1}
            </Typography>
            <Typography variant="subtitle2" gutterBottom>
              {line2}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}

RatingSlider.propTypes = {
  marks: PropTypes.array,
  step: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  default: PropTypes.oneOfType([PropTypes.array, PropTypes.number]),
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.number]),
  sliderOnChange: PropTypes.func,
  helperText: PropTypes.bool,
  labelEnd: PropTypes.string,
  labelMid: PropTypes.string,
  labelStart: PropTypes.string,
  valueLabel: PropTypes.string
};
